/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './booking-header.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/common';
import * as import3 from '@angular/router';
import * as import4 from '../../../../app/booking-management/booking-header/booking-header.component';
import * as import5 from '../../../../app/booking-management/booking-header/booking-header.service';
import * as import6 from '@angular/material';
import * as import7 from '../../../../app/notification/notification.service';
const styles_BookingHeaderComponent:any[] = [import0.styles];
export const RenderType_BookingHeaderComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_BookingHeaderComponent,
  data: {}
}
);
function View_BookingHeaderComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'href',
        'javascript:void(0);'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.bookingDetailClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),['Booking details']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,co.isActive('edit-booking'));
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_BookingHeaderComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[
      [
        'href',
        'javascript:void(0);'
      ]
      ,
      [
        'name',
        'linkPayroll'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.payrollClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),['Payroll & Billing']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,co.isActive('payroll-billing'));
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_BookingHeaderComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'button inverse'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.linkBooking()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Link booking']))
  ]
  ,(null as any),(null as any));
}
function View_BookingHeaderComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'button pink'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.unlinkBooking()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Unlink']))
  ]
  ,(null as any),(null as any));
}
function View_BookingHeaderComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'button pink'
      ]
      ,
      [
        'id',
        'undoCancelBtn'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.undoCancelClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Undo cancel']))
  ]
  ,(null as any),(null as any));
}
function View_BookingHeaderComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'button pink'
      ]
      ,
      [
        'name',
        'unable_to_Service'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showDialogBoxClick(false)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Unable to Service']))
  ]
  ,(null as any),(null as any));
}
function View_BookingHeaderComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'button pink'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showDialogBoxClick(true)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Cancel Booking']))
  ]
  ,(null as any),(null as any));
}
function View_BookingHeaderComponent_9(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'button inverse'
      ]
      ,
      [
        'name',
        'dupBtn'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.duplicateClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Duplicate']))
  ]
  ,(null as any),(null as any));
}
function View_BookingHeaderComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),24,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_4)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_5)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_6)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_7)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_8)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_9)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'sep'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'button inverse'
      ]
      ,
      [
        'name',
        'saveBtn'
      ]

    ]
      ,[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.saveClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Save'])),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.isCurrentUserAdminOrBookingOfficer() && !co.hasLinkId) && !co.unlinkPress);
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.isCurrentUserAdminOrBookingOfficer() && co.hasLinkId);
    ck(v,6,0,currVal_1);
    const currVal_2:any = (co.isCurrentUserAdminOrBookingOfficer() && co.isUnableToServiceOrCanceled_States());
    ck(v,9,0,currVal_2);
    const currVal_3:boolean = (!co.isCancelOrUnable && !co.isCurrentUserIndividualClientOrOrg());
    ck(v,12,0,currVal_3);
    const currVal_4:boolean = (!co.isCancelOrUnable && co.isClientLinked);
    ck(v,15,0,currVal_4);
    const currVal_5:any = co.isClientLinked;
    ck(v,18,0,currVal_5);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_6:boolean = (((((((!co.declinePressed && !co.invitePress) && !co.autoInvitePress) && !co.isAddedToQueue) && !co.stopAutoInvitePress) && !co.unAssignPress) && !co.reAssignPress) && !co.unlinkPress);
    ck(v,22,0,currVal_6);
  });
}
function View_BookingHeaderComponent_11(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'button pink'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showDialogBoxInterpreter(true)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Decline\n            ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingHeaderComponent_12(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'button inverse'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showDialogBoxInterpreter(false)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Accept\n            ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingHeaderComponent_10(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),14,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'button',[[
        'class',
        'button green'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import3.RouterLink,[
      import3.Router,
      import3.ActivatedRoute,
      [
        8,
        (null as any)
      ]
      ,
      import1.Renderer,
      import1.ElementRef
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    (l()(),import1.ɵted((null as any),['MESSAGE OFFICE'])),
    (l()(),import1.ɵted((null as any),['\n\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_11)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'sep'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_12)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,4,0,((('/users/' + co.getInterpreterId()) + '/inbox/') + co.bookingModel.id));
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = (!co.disableReject && co.isInProgressOrAllocatedState());
    ck(v,8,0,currVal_1);
    const currVal_2:boolean = (!co.disableAccept && co.isInProgressOrAllocatedState());
    ck(v,13,0,currVal_2);
  },(null as any));
}
export function View_BookingHeaderComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),55,'section',[[
        'id',
        'static-flow'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),21,'section',[[
        'id',
        'submenu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),12,'nav',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'href',
        'javascript:void(0);'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.BookingHeaderComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.infoClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),['Booking info'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_1)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_2)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_3)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingHeaderComponent_10)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),29,'section',[[
        'id',
        'steps'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),26,'nav',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'href',
        'javascript:void(0);'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod([
      'active',
      'passed'
    ]
    ),
    (l()(),import1.ɵted((null as any),['Requested'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'href',
        'javascript:void(0);'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod([
      'active',
      'passed'
    ]
    ),
    (l()(),import1.ɵted((null as any),['In Progress'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'href',
        'javascript:void(0);'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod([
      'active',
      'passed'
    ]
    ),
    (l()(),import1.ɵted((null as any),['Allocated'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'href',
        'javascript:void(0);'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'href',
        'javascript:void(0);'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.BookingHeaderComponent = v.component;
    const currVal_0:any = ck(v,8,0,(co.isActive('booking-job') || co.isActive('job-detail')));
    ck(v,7,0,currVal_0);
    const currVal_1:boolean = !co.isCurrentUserInterpreter();
    ck(v,12,0,currVal_1);
    const currVal_2:any = (co.isCurrentUserAdminOrBookingOfficer() && !co.isActiveState('Cancelled_no_charge'));
    ck(v,15,0,currVal_2);
    const currVal_3:any = co.showButtons;
    ck(v,19,0,currVal_3);
    const currVal_4:any = co.isCurrentUserInterpreter();
    ck(v,22,0,currVal_4);
    const currVal_5:any = ck(v,31,0,co.isActiveState('Requested'),co.isActiveState('Requested'));
    ck(v,30,0,currVal_5);
    const currVal_6:any = ck(v,36,0,co.isActiveState('In_progress'),co.isActiveState('In_progress'));
    ck(v,35,0,currVal_6);
    const currVal_7:any = ck(v,41,0,co.isActiveState('Allocated'),co.isActiveState('Allocated'));
    ck(v,40,0,currVal_7);
    const currVal_8:any = ck(v,46,0,(co.isActiveState('Service_completed') || co.isActiveState('Cancelled_chargeable')));
    ck(v,45,0,currVal_8);
    const currVal_10:any = ck(v,51,0,(((((co.isActiveState('Unable_to_service') || co.isActiveState('Cancelled_no_charge')) || co.isActiveState('Claimed')) || co.isActiveState('Cancelled_claimed')) || co.isActiveState('Claimed_exported')) || co.isActiveState('Cancelled_claimed_exported')));
    ck(v,50,0,currVal_10);
  },(ck,v) => {
    var co:import4.BookingHeaderComponent = v.component;
    const currVal_9:any = (co.isActiveState('Cancelled_chargeable')? 'Cancelled Chargeable': 'Service Completed');
    ck(v,47,0,currVal_9);
    const currVal_11:any = (co.isActiveState('Cancelled_no_charge')? 'Cancelled No Charge': (co.isActiveState('Unable_to_service')? 'Unable To Service': (co.isActiveState('Claimed')? 'Claimed': (co.isActiveState('Cancelled_claimed')? 'Cancelled Claimed': 'Finished'))));
    ck(v,52,0,currVal_11);
  });
}
function View_BookingHeaderComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(16777216,(null as any),(null as any),1,'app-booking-header',([] as any[]),(null as any),(null as any),(null as any),View_BookingHeaderComponent_0,RenderType_BookingHeaderComponent)),
    import1.ɵdid(245760,(null as any),0,import4.BookingHeaderComponent,[
      import1.NgZone,
      import5.BookingHeaderService,
      import3.Router,
      import6.MdDialog,
      import1.ViewContainerRef,
      import7.NotificationServiceBus
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const BookingHeaderComponentNgFactory:import1.ComponentFactory<import4.BookingHeaderComponent> = import1.ɵccf('app-booking-header',import4.BookingHeaderComponent,View_BookingHeaderComponent_Host_0,{
  bookingModel: 'bookingModel',
  paymentModel: 'paymentModel',
  oldModel: 'oldModel',
  isCancelOrUnable: 'isCancelOrUnable',
  invitePress: 'invitePress',
  isAddedToQueue: 'isAddedToQueue',
  autoInvitePress: 'autoInvitePress',
  stopAutoInvitePress: 'stopAutoInvitePress',
  unAssignPress: 'unAssignPress',
  reAssignPress: 'reAssignPress',
  unlinkPress: 'unlinkPress',
  showButtons: 'showButtons',
  disableAccept: 'disableAccept',
  disableReject: 'disableReject',
  declinePressed: 'declinePressed',
  hasLinkId: 'hasLinkId',
  isAutoInvite: 'isAutoInvite'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/booking-header/booking-header.component.ngfactory.ts